import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';

import messages from './GeneralMeetingView.intl';

import ArticleDetail from 'common/components/ArtricleDetailPage/ArticleDetailPage';

import { ANCHOR } from 'common/consts/common';

import LanguageService from 'services/Language.service';
import GeneralMeetingsStore from 'stores/GeneralMeetings.store';
import ContentStore from 'stores/Content.store';
import Location from 'stores/Location.store';

@injectIntl
@withRouter
@observer
export default class GeneralMeetingView extends Component {
  state = {
    article: null
  };

  async getArticle(slug) {
    const availableLanguages = LanguageService.getSortedLanguages();

    let article = await availableLanguages.reduce(
      (previousPromise, nextLang) => {
        return previousPromise.then(
          result =>
            result ||
            GeneralMeetingsStore.getGeneralMeetingItemBySlug(slug, nextLang)
        );
      },
      Promise.resolve()
    );

    if (article) {
      if (LanguageService.getLang() !== article.system.language) {
        article = await GeneralMeetingsStore.getGeneralMeetingItemById(
          article.id
        );
      }
    }
    LanguageService.adjustSlugToLanguage(this, article);

    article
      ? this.setState({ article })
      : this.props.history.push(
          `${ANCHOR.GENERAL_MEETINGS[LanguageService.getLang()]}`
        );
  }

  contactPerson = {};

  async componentDidMount() {
    reaction(
      () => ContentStore.isLoaded,
      () => {
        this.contactPerson = ContentStore.content
          ? ContentStore.content.pressRoomContactPerson
          : {};
      },
      {
        fireImmediately: true
      }
    );
    let articleSlug = this.props.match.params.slug;

    this.getArticle(articleSlug);
  }

  didComeFromListing() {
    const lastPath = Location.getLastLocation();
    return lastPath && lastPath.pathname === ANCHOR.GENERAL_MEETINGS;
  }

  render() {
    const { article } = this.state;

    return (
      <ArticleDetail
        messages={messages}
        didComeFromListing={this.didComeFromListing}
        article={article}
        viewWithOnlyArticle
        defaultPreviousPath={ANCHOR.GENERAL_MEETINGS}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/GeneralMeeting/GeneralMeetingView.js